import { Flex } from "@chakra-ui/react";
import { Outlet } from "@tanstack/react-router";
import { DitherGradient } from "components/ditherGradient/DitherGradient";

export const PublicLayout = () => (
  <Flex
    flexDir="column"
    minH="100vh"
    position="relative"
    backgroundColor="bg.container"
  >
    <DitherGradient
      bandWidth={1}
      color2="dither.neutral"
      curve={0.8}
      diagonalAlignment={1}
      verticalAlignment={1}
      pixelSize={1.5}
      position="absolute"
      inset="0"
      pointerEvents="none"
    />
    <Flex
      flex="1"
      data-cy="public-layout"
      margin="0 auto"
      width="100%"
      padding={{ base: "2.5", lg: "6", md: "40px 60px", sm: "6" }}
      alignItems="center"
      justifyContent="center"
      position="relative"
      zIndex="1"
    >
      <Outlet />
    </Flex>
  </Flex>
);
